import {
  configureStore,
  ThunkAction,
  Action,
  combineReducers,
  AnyAction,
  Reducer,
} from "@reduxjs/toolkit";
import * as Sentry from "@sentry/react";

import {
  AdvisoryBuyerReducer,
  AdvisoryDistributionReducer,
  AdvisoryExitPlanReducer,
  AdvisoryFireblocksWalletReducer,
  AdvisoryProjectReducer,
  AdvisoryPurchaseReducer,
  AdvisoryTrancheReducer,
  AssetsExchangeReducer,
  AssetsFireblocksReducer,
  AssetsSnapshotsReducer,
  AuthReducer,
  CapitalFormationResourcesReducer,
  CapitalFormationSnapshotsReducer,
  EmailSystemReducer,
  EmailTemplatesReducer,
  FiltersReducer,
  FiltersDataReducer,
  FinanceCapitalMovementReducer,
  FinanceCapitalMovementDividendReducer,
  FinanceDistributionModelingReducer,
  HrCapitalFormationDistributionReducer,
  HrCapitalFormationTierReducer,
  HrDocumentListReducer,
  HrEmployeeReducer,
  HrEmployeeCompensationReducer,
  HrEmployeeLeaveReducer,
  HrHolidayCalendarReducer,
  HrQuantDistributionReducer,
  HrQuantPerformanceReducer,
  HrVentureDistributionReducer,
  HrVenturePerformanceReducer,
  HrVenturePointsReducer,
  InvestmentDocumentListReducer,
  InvestmentInvestorProfileReducer,
  InvestmentNoteTypeReducer,
  InvestmentReportingReducer,
  InvestmentSourceExchangeReducer,
  InvestmentTagsReducer,
  LibraryExpectedConversionReducer,
  LibraryConversionGradingReducer,
  LinkAgentPayoutsReducer,
  LinkAgentProfilesReducer,
  LinkAgentReportsReducer,
  ProductFundReducer,
  PwmDocumentListReducer,
  PwmNoteTypeReducer,
  PwmProfileReducer,
  PwmTradingReducer,
  PwmExchangeReducer,
  PwmStrategyReducer,
  PwmExchangeItemReducer,
  PwmStrategyItemReducer,
  SidebarReducer,
  TaskManagementEventReducer,
  TaskManagementNoteTypeReducer,
  TaskManagementRecurringTaskReducer,
  TaskManagementRemindReducer,
  TaskManagementRemindTypeReducer,
  TaskManagementTaskReducer,
  TaskManagementTaskTypeReducer,
  UserInteractionAnnouncementReducer,
  UserInteractionNotificationsReducer,
  UserInteractionReportTypeReducer,
  UserInteractionReportsReducer,
  UserInteractionStatementTypeReducer,
  UserInteractionStatementsReducer,
  UserInteractionUpcomingEventsReducer,
  UserInteractionWeeklyUpdatesReducer,
  UserPortalEmployeeHomepageReducer,
  UsersReducer,
  VentureAssetAttributionReducer,
  VentureBlockchainReducer,
  VentureContactReducer,
  VentureContactTypeReducer,
  VentureDocumentListReducer,
  VentureInvestmentMethodReducer,
  VentureNoteTypeReducer,
  VentureOriginationSourceReducer,
  VentureProjectProfileReducer,
  VentureProjectTypeReducer,
  VentureSectorReducer,
  VentureSnapshotsReducer,
  VentureTagsReducer,
  VentureValuationControlReducer,
  WesterosClientReducer,
  WesterosDocumentListReducer,
  WesterosNoteTypeReducer,
  WesterosServiceReducer,
  WesterosTagsReducer,
} from "./slices";
import { AuthActions } from "./slices/auth/enums";

const combinedReducer = combineReducers({
  AdvisoryBuyerReducer,
  AdvisoryDistributionReducer,
  AdvisoryExitPlanReducer,
  AdvisoryFireblocksWalletReducer,
  AdvisoryProjectReducer,
  AdvisoryPurchaseReducer,
  AdvisoryTrancheReducer,
  AssetsExchangeReducer,
  AssetsFireblocksReducer,
  AssetsSnapshotsReducer,
  AuthReducer,
  CapitalFormationResourcesReducer,
  CapitalFormationSnapshotsReducer,
  EmailSystemReducer,
  EmailTemplatesReducer,
  FiltersReducer,
  FiltersDataReducer,
  FinanceCapitalMovementReducer,
  FinanceCapitalMovementDividendReducer,
  FinanceDistributionModelingReducer,
  HrCapitalFormationDistributionReducer,
  HrCapitalFormationTierReducer,
  HrDocumentListReducer,
  HrEmployeeReducer,
  HrEmployeeCompensationReducer,
  HrEmployeeLeaveReducer,
  HrHolidayCalendarReducer,
  HrQuantDistributionReducer,
  HrQuantPerformanceReducer,
  HrVentureDistributionReducer,
  HrVenturePerformanceReducer,
  HrVenturePointsReducer,
  InvestmentDocumentListReducer,
  InvestmentInvestorProfileReducer,
  InvestmentNoteTypeReducer,
  InvestmentReportingReducer,
  InvestmentSourceExchangeReducer,
  InvestmentTagsReducer,
  LibraryExpectedConversionReducer,
  LibraryConversionGradingReducer,
  LinkAgentPayoutsReducer,
  LinkAgentProfilesReducer,
  LinkAgentReportsReducer,
  ProductFundReducer,
  PwmDocumentListReducer,
  PwmNoteTypeReducer,
  PwmProfileReducer,
  PwmTradingReducer,
  PwmExchangeReducer,
  PwmStrategyReducer,
  PwmExchangeItemReducer,
  PwmStrategyItemReducer,
  SidebarReducer,
  TaskManagementEventReducer,
  TaskManagementNoteTypeReducer,
  TaskManagementRecurringTaskReducer,
  TaskManagementRemindReducer,
  TaskManagementRemindTypeReducer,
  TaskManagementTaskReducer,
  TaskManagementTaskTypeReducer,
  UserInteractionAnnouncementReducer,
  UserInteractionNotificationsReducer,
  UserInteractionReportTypeReducer,
  UserInteractionReportsReducer,
  UserInteractionStatementTypeReducer,
  UserInteractionStatementsReducer,
  UserInteractionUpcomingEventsReducer,
  UserInteractionWeeklyUpdatesReducer,
  UserPortalEmployeeHomepageReducer,
  UsersReducer,
  VentureAssetAttributionReducer,
  VentureBlockchainReducer,
  VentureContactReducer,
  VentureContactTypeReducer,
  VentureDocumentListReducer,
  VentureInvestmentMethodReducer,
  VentureNoteTypeReducer,
  VentureOriginationSourceReducer,
  VentureProjectProfileReducer,
  VentureProjectTypeReducer,
  VentureSectorReducer,
  VentureSnapshotsReducer,
  VentureTagsReducer,
  VentureValuationControlReducer,
  WesterosClientReducer,
  WesterosDocumentListReducer,
  WesterosNoteTypeReducer,
  WesterosServiceReducer,
  WesterosTagsReducer,
});

const rootReducer: Reducer = (state: RootState, action: AnyAction) => {
  if (action.type === AuthActions.SIGN_OUT) {
    state = {} as RootState;
  }

  return combinedReducer(state, action);
};

const sentryReduxEnhancer =
  process.env.REACT_APP_SENTRY_DSN && process.env.REACT_APP_PROJECT_ENV
    ? Sentry.createReduxEnhancer({
        // Optionally pass options listed below
      })
    : null;

export const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== "production",
  enhancers: sentryReduxEnhancer ? [sentryReduxEnhancer] : undefined,
});

export type AppDispatch = typeof store.dispatch;

export type RootState = ReturnType<typeof combinedReducer>;

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
